var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parcel"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.parcel.q))])])}
var staticRenderFns = []

export { render, staticRenderFns }